[
	{
		"name": "accounts",
		"tag": "Accounts",
		"description": "A business on Whop: profile, wallet, capabilities, settings.",
		"group": "Core Resources"
	},
	{
		"name": "users",
		"tag": "Users",
		"description": "A person on Whop: profile and connected identities.",
		"group": "Core Resources"
	},
	{
		"name": "team-members",
		"tag": "Team Members",
		"description": "An account's team members and the roles that scope their access.",
		"group": "Core Resources"
	},
	{
		"name": "members",
		"tag": "Members",
		"description": "One buyer's relationship with an account, across all their purchases.",
		"group": "Core Resources"
	},
	{
		"name": "economic-intelligence",
		"tag": "Economic Intelligence",
		"description": "What an account should do next to grow, generated from its own data.",
		"group": "Core Resources"
	},
	{
		"name": "webhooks",
		"tag": "Webhooks",
		"description": "Event notifications pushed to your server as things happen.",
		"group": "Core Resources"
	},
	{
		"name": "stats",
		"tag": "Stats",
		"description": "Aggregated financial, audience, and traffic reporting.",
		"group": "Core Resources"
	},
	{
		"name": "verifications",
		"tag": "Verifications",
		"description": "Legal identity required before payouts and card issuing.",
		"group": "Core Resources"
	},
	{
		"name": "exports",
		"tag": "Exports",
		"description": "Asynchronous CSV dumps of an account's dashboard data.",
		"group": "Core Resources"
	},
	{
		"name": "notifications",
		"tag": "Notifications",
		"description": "The user's notification feed: unread badges, mark-read, app sends, and the topic catalog.",
		"group": "Notifications"
	},
	{
		"name": "payments",
		"tag": "Payments",
		"description": "A charge against a buyer, and the step they still owe.",
		"group": "Payments"
	},
	{
		"name": "refunds",
		"tag": "Refunds",
		"description": "Money returned to a buyer from a payment.",
		"group": "Payments"
	},
	{
		"name": "confirmation-tokens",
		"tag": "Confirmation Tokens",
		"description": "A short-lived reference to payment details collected from a buyer.",
		"group": "Payments"
	},
	{
		"name": "setup-intents",
		"tag": "Setup Intents",
		"description": "Saving a buyer's payment method without charging it.",
		"group": "Payments"
	},
	{
		"name": "payment-rules",
		"tag": "Payment Rules",
		"description": "Rules an account writes to decide its own payments.",
		"group": "Payments"
	},
	{
		"name": "disputes",
		"tag": "Disputes",
		"description": "Chargebacks filed against an account, with evidence and outcomes.",
		"group": "Payments"
	},
	{
		"name": "dispute-alerts",
		"tag": "Dispute alerts",
		"description": "Issuer warnings that arrive before a chargeback does.",
		"group": "Payments"
	},
	{
		"name": "resolution-center-cases",
		"tag": "Resolution Center Cases",
		"description": "File or respond to a case against a payment, as the buyer or the merchant.",
		"group": "Payments"
	},
	{
		"name": "ledgers",
		"tag": "Ledgers",
		"description": "The activity feed behind an account or user's balance.",
		"group": "Money"
	},
	{
		"name": "payouts",
		"tag": "Payouts",
		"description": "Send money from a balance to a bank or wallet.",
		"group": "Money"
	},
	{
		"name": "cards",
		"tag": "Cards",
		"description": "Issue cards that spend from a balance.",
		"group": "Money"
	},
	{
		"name": "cashback-rules",
		"tag": "Cashback Rules",
		"description": "Configure platform-sponsored card cashback.",
		"group": "Money"
	},
	{
		"name": "transfers",
		"tag": "Transfers",
		"description": "Move funds between Whop accounts and users.",
		"group": "Money"
	},
	{
		"name": "deposits",
		"tag": "Deposits",
		"description": "Add funds to a balance.",
		"group": "Money"
	},
	{
		"name": "swaps",
		"tag": "Swaps",
		"description": "Convert a balance between currencies.",
		"group": "Money"
	},
	{
		"name": "products",
		"tag": "Products",
		"description": "The things you sell. Each owns plans and a store page.",
		"group": "Commerce"
	},
	{
		"name": "plans",
		"tag": "Plans",
		"description": "Pricing for a product: one-time, recurring, trials, stock.",
		"group": "Commerce"
	},
	{
		"name": "promo-codes",
		"tag": "Promo Codes",
		"description": "Discounts that creators configure for checkout.",
		"group": "Commerce"
	},
	{
		"name": "memberships",
		"tag": "Memberships",
		"description": "A customer's purchase of a plan, from checkout through cancellation.",
		"group": "Commerce"
	},
	{
		"name": "checkout-configurations",
		"tag": "Checkout Configurations",
		"description": "Turn a plan into a shareable, prefilled checkout link.",
		"group": "Commerce"
	},
	{
		"name": "payment-method-domains",
		"tag": "Payment Method Domains",
		"description": "Domains verified to show wallet payment methods like Apple Pay at checkout.",
		"group": "Commerce"
	},
	{
		"name": "shipments",
		"tag": "Shipments",
		"description": "Track the delivery of an order by its carrier tracking number.",
		"group": "Commerce"
	},
	{
		"name": "partner-referral-requests",
		"tag": "Partner Referral Requests",
		"description": "Request business attribution and manage owner approval.",
		"group": "Partners"
	},
	{
		"name": "partners",
		"tag": "Partners",
		"description": "Your partner profile, referral links, payout rates, and referred businesses.",
		"group": "Partners"
	},
	{
		"name": "bounties",
		"tag": "Bounties",
		"description": "Paid tasks with reviewed submissions and escrowed rewards.",
		"group": "Workforce"
	},
	{
		"name": "bounty-submissions",
		"tag": "Bounty Submissions",
		"description": "Work submitted to a bounty, from attempt to payout.",
		"group": "Workforce"
	},
	{
		"name": "people",
		"tag": "People",
		"description": "Visitors and customers of an account, with identity, purchase, and traffic profiles.",
		"group": "Tracking"
	},
	{
		"name": "events",
		"tag": "Events",
		"description": "Conversion and engagement events tracked for attribution.",
		"group": "Tracking"
	},
	{
		"name": "ads",
		"tag": "Ads",
		"description": "The creative: copy, assets, and destination URL.",
		"group": "Ads"
	},
	{
		"name": "ad-conversion-value-rules",
		"tag": "Ad Conversion Value Rules",
		"description": "Modify how conversion events are delivered to ad networks.",
		"group": "Ads"
	},
	{
		"name": "ad-campaigns",
		"tag": "Ad Campaigns",
		"description": "Platform, objective, and budget for a set of ads.",
		"group": "Ads"
	},
	{
		"name": "ad-groups",
		"tag": "Ad Groups",
		"description": "Audience, placements, and schedule within a campaign.",
		"group": "Ads"
	},
	{
		"name": "audiences",
		"tag": "Audiences",
		"description": "Reusable targeting lists for ad groups.",
		"group": "Ads"
	},
	{
		"name": "files",
		"tag": "Files",
		"description": "Upload files and attach them wherever Whop accepts documents.",
		"group": "Media"
	},
	{
		"name": "media",
		"tag": "Media",
		"description": "AI-generated assets, billed from a balance, attachable wherever files are accepted.",
		"group": "Media"
	},
	{
		"name": "social-accounts",
		"tag": "Social Accounts",
		"description": "Connected Facebook and Instagram accounts that run ads.",
		"group": "Identity"
	},
	{
		"name": "apps",
		"tag": "Apps",
		"description": "Apps you build on Whop: metadata, hosted builds, runtime logs.",
		"group": "Developer"
	},
	{
		"name": "domains",
		"tag": "Domains",
		"description": "Custom domains assigned to hosted apps.",
		"group": "Developer"
	},
	{
		"name": "app-builds",
		"tag": "App Builds",
		"description": "Versioned build artifacts deployed to an app's platforms.",
		"group": "Developer"
	},
	{
		"name": "api-keys",
		"tag": "API Keys",
		"description": "Programmatic credentials for an account or app.",
		"group": "Developer"
	},
	{
		"name": "api-logs",
		"tag": "Api Logs",
		"description": "Requests made to Whop's API with your account's API keys.",
		"group": "Developer"
	},
	{
		"name": "permissions",
		"tag": "Permissions",
		"description": "What your credential is allowed to do on a resource.",
		"group": "Developer"
	},
	{
		"name": "experiments",
		"tag": "Experiments",
		"description": "Feature flags and A/B experiments for gradual rollout and statistical measurement.",
		"group": "Developer"
	}
]
